module.exports = __webpack_public_path__ + "img/EA130.c3ccb804.png";